var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canReadChannels
    ? _c("tr", [
        _c(
          "td",
          {
            staticClass: "p-2 text-truncate",
            staticStyle: { "min-width": "80px" },
          },
          [
            _c("ChannelIcon", {
              staticClass: "mr-2",
              class: _vm.validationStatusColor,
              attrs: { type: _vm.channelData.type },
            }),
            _vm._v(" "),
            _vm.channelData.type === _vm.CHANNEL_TYPE.MOBILE
              ? _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("watchmen.channels.type.mobile")) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.channelData.type === _vm.CHANNEL_TYPE.PHONE
              ? _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("watchmen.channels.type.phone")) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.channelData.type === _vm.CHANNEL_TYPE.EMAIL
              ? _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("watchmen.channels.type.email")) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("td", { staticClass: "p-2" }, [
          _c("div", {
            staticClass: "text-mono text-truncate",
            attrs: { title: _vm.channelData.value },
            domProps: { textContent: _vm._s(_vm.channelData.value) },
          }),
        ]),
        _vm._v(" "),
        _c(
          "td",
          { staticClass: "p-2" },
          [
            _c("ChannelValidation", {
              attrs: { channel: _vm.channel },
              on: { onChannelFetched: _vm.onChannelFetched },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("td", { staticClass: "p-2" }, [
          _vm.arrayLength(_vm.channelData.profiles)
            ? _c(
                "div",
                {
                  staticClass: "d-flex flex-column",
                  staticStyle: { gap: "4px" },
                },
                _vm._l(_vm.channelData.profiles, function (profile) {
                  return _c(
                    "div",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: {
                            to: "/configurations/profiles/" + profile.id,
                          },
                        },
                        [
                          _c("ProfileIcon", {
                            staticClass: "mr-2",
                            attrs: { icon: profile.icon },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-truncate" }, [
                            _vm._v(_vm._s(profile.name)),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "p-2" }, [
          _vm.arrayLength(_vm.channelData.rmProcedures)
            ? _c(
                "div",
                [
                  _c("i", {
                    staticClass: "fa fa-lock fa-lg",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.channelData.rmProcedures, function (rmProcedure) {
                    return _c(
                      "div",
                      { staticClass: "text-truncate" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "text-truncate",
                            attrs: {
                              to: {
                                name: "RemoteMonitoringShow",
                                params: { id: rmProcedure.id },
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(rmProcedure.name) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "td",
          { staticClass: "p-2" },
          [
            _vm.canUpdateChannels
              ? _c(
                  "Button2",
                  {
                    staticClass: "btn-sm btn-light",
                    attrs: {
                      disabled:
                        _vm.arrayLength(_vm.channelData.rmProcedures) || false,
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("onEditChannel", _vm.channelData.id)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("global.edit")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }